import $ from '../vendor/jquery';

$('.block-accordion .accordion-toggle').click(function(e) {
  $(this).parents('.block-accordion').toggleClass('open');
  $(this).parent().find('.accordion-content').slideToggle();
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/accordions.js